import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MEDIUM, LARGE } from "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/shadows/shadows.js";
import { typography } from "../../../../../themes/typography/typography.js";
import { Button } from "../../common/button/button.js";
import "react/jsx-runtime";
import "color-alpha";
import { ExternalTheme } from "../../../../../themes/external-theme/external-theme.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "react";
import "../../../../../hooks/useFilterEmployees/useFilterEmployees.js";
import "../../../../../type/Translations.js";
import "../../../../../type/Employee.js";
import "../../../../../utils/array.js";
import "fast-memoize";
import "../../../../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "lodash";
import "lodash/debounce.js";
import "../../../../../hooks/useResponsive.js";
import "../../../smileview-section/hooks/useWindowSize.js";
import "../../common/button/styles.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
const CUSTOM_LARGE = 1320;
const HeroContainer = styled(Box)(
  ({ theme: theme2, paddingTop, minHeight }) => ({
    display: "flex",
    alignItems: "flex-start",
    backgroundColor: theme2.palette.primary[10],
    position: "relative",
    paddingTop: paddingTop || "32px",
    minHeight,
    [theme2.breakpoints.down(MEDIUM)]: {
      paddingTop: paddingTop || 0
    }
  })
);
const LeftColumn = styled(Box)({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  alignItems: "left",
  [ExternalTheme.breakpoints.down(LARGE)]: {
    marginTop: "32px",
    maxWidth: "100%"
  }
});
const RightColumn = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  alignSelf: "flex-end",
  position: "relative",
  [ExternalTheme.breakpoints.down(CUSTOM_LARGE)]: {
    flex: 0,
    display: "none"
  }
});
const BreadCrumbWrapper = styled(Box)({
  display: "flex",
  marginBottom: "16px"
});
const BreadCrumbItem = styled("a")(({ theme: theme2, isLast }) => ({
  ...typography["Lato Emphasized 2"],
  color: isLast ? theme2.palette.primary[800] : theme2.palette.grey[700],
  cursor: isLast ? "default" : "pointer",
  marginRight: isLast ? 0 : "16px",
  textDecoration: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
const Title = styled("h1")(({ theme: theme2 }) => ({
  color: theme2.palette.primary[900],
  ...typography["DM Serif H1"],
  marginBottom: "24px",
  marginTop: 0,
  [theme2.breakpoints.down(CUSTOM_LARGE)]: {
    ...typography["DM Serif H2"]
  },
  [theme2.breakpoints.down(MEDIUM)]: {
    ...typography["DM Serif H3"],
    marginBottom: "32px"
  }
}));
const KununuImage = styled("img")({
  width: 78,
  height: 102,
  marginRight: "6px",
  [ExternalTheme.breakpoints.up(MEDIUM)]: {
    marginRight: "16px"
  }
});
const HeroImageBig = styled("img")({
  width: 580,
  height: 580,
  display: "flex",
  position: "relative",
  marginBottom: "48px",
  zIndex: 1,
  [ExternalTheme.breakpoints.down(CUSTOM_LARGE)]: {
    display: "none"
  }
});
const HeroImageSmall = styled("img")({
  display: "none",
  [ExternalTheme.breakpoints.down(MEDIUM)]: {
    maxWidth: 330,
    maxHeight: 330,
    alignSelf: "center"
  },
  [ExternalTheme.breakpoints.up(MEDIUM)]: {
    width: "40%"
  },
  [ExternalTheme.breakpoints.down(CUSTOM_LARGE)]: {
    display: "flex",
    marginBottom: "10px",
    objectFit: "cover",
    objectPosition: "top"
  }
});
const JobInfo = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "12px"
});
const JobInfoLine = styled(Box)({
  display: "flex",
  alignItems: "center"
});
const JobInfoLineIcon = styled("img")({
  marginRight: "8px"
});
const JobInfoLineText = styled(Typography)(({ theme: theme2 }) => ({
  ...typography["Lato H5"],
  color: theme2.palette.grey[800],
  [theme2.breakpoints.down(MEDIUM)]: {
    ...typography["Lato Emphasized 1"],
    textWrap: "wrap"
  }
}));
const ButtonsWrapper = styled(Box)({
  display: "flex",
  marginTop: "24px",
  [ExternalTheme.breakpoints.down(CUSTOM_LARGE)]: {
    marginBottom: "32px"
  },
  [ExternalTheme.breakpoints.down(MEDIUM)]: {
    flexDirection: "column",
    gap: "16px",
    marginTop: "32px",
    button: {
      width: "100%",
      marginLeft: 0
    }
  }
});
const IconButton = styled(Button)(({ theme: theme2 }) => ({
  color: theme2.palette.primary[800],
  border: `1px solid ${theme2.palette.primary[800]}`,
  display: "flex",
  marginLeft: "16px"
}));
const Icon = styled("img")({
  marginRight: "8px",
  width: 25,
  height: 24
});
const FooterDesktop = styled(Box)(({ theme: theme2 }) => ({
  backgroundColor: theme2.palette.primary[50],
  width: "100%",
  height: "150px",
  position: "absolute",
  bottom: 0,
  display: "flex",
  alignItems: "center",
  [theme2.breakpoints.down(CUSTOM_LARGE)]: {
    display: "none"
  }
}));
const GoogleWidget = styled(Box)(({ theme: theme2 }) => ({
  width: "auto",
  height: "150px",
  display: "flex",
  alignItems: "center",
  paddingBottom: 4,
  ".grw-net-widget": {
    margin: 0,
    "> .grw-net-widget-three-type-1": {
      ".grw-net-text": {
        ...typography["Lato Caption"]
      },
      ".grw-net-text-bold": {
        ...typography["Lato Caption Bold"]
      },
      border: `1px solid ${theme2.palette.grey[300]}`,
      boxShadow: "0px 4px 4px 0px #00000040",
      borderRadius: "16px",
      padding: "12px"
    }
  },
  [theme2.breakpoints.down(MEDIUM)]: {
    ".grw-net-widget > .grw-net-widget-three-type-1": {
      padding: "8px",
      ".grw-net-widget-three .grw-net-stars": {
        marginBottom: "4px"
      }
    }
  }
}));
const FooterMobile = styled(Box)(({ theme: theme2 }) => ({
  backgroundColor: theme2.palette.primary[50],
  width: "100%",
  height: "150px",
  bottom: 0,
  display: "flex",
  alignItems: "center",
  [theme2.breakpoints.up(CUSTOM_LARGE)]: {
    display: "none"
  }
}));
export {
  BreadCrumbItem,
  BreadCrumbWrapper,
  ButtonsWrapper,
  FooterDesktop,
  FooterMobile,
  GoogleWidget,
  HeroContainer,
  HeroImageBig,
  HeroImageSmall,
  Icon,
  IconButton,
  JobInfo,
  JobInfoLine,
  JobInfoLineIcon,
  JobInfoLineText,
  KununuImage,
  LeftColumn,
  RightColumn,
  Title
};
